import { inject } from "mobx-react";
import React from "react";
import { Route, RouteComponentProps, Switch, useHistory } from "react-router";
import { IndexView, ShowView, withBreadCrumbs } from "lego-gui-lib/lib";
import i18next from "i18next";
import { WebUserRoleMappingSchema } from "./schema";
import { CreateView } from "lego-gui-lib";
import { observer } from "mobx-react-lite";

export const WebUserRoleMapping = {
  url: "/webUserRoleMappings",
  handler: (props: RouteComponentProps<any>) => {
    const baseUrl = props.match.url;
    const title = i18next.t("hns:webUserRoleMapping:domain_plural");
    return withBreadCrumbs(
      { to: baseUrl, children: title },
      <>
        <Switch>
          <Route exact={true} path={baseUrl} component={Index} />
          <Route path={baseUrl + "/create/:id"} component={Create} />
          <Route path={baseUrl + "/create"} component={Create} />
          <Route path={baseUrl + "/:id"} component={Show} />
        </Switch>
      </>
    );
  }
};

const injectDataSource = (comp: any) =>
  inject("webUserRoleMapping", "i18n")(observer(comp));

export const Index = injectDataSource(
  ({ webUserRoleMapping, i18n, ...rest }: any) => {
    const title = i18n.t("hns:webUserRoleMapping:domain", { count: 2 });
    return (
      <IndexView
        dataSource={webUserRoleMapping.listDataSource}
        {...rest}
        title={title}
        rowButtons={{ edit: true, delete: true, copy: true, export: true }}
        toolbarButtons={{ edit: true, delete: true, copy: true, export: true }}
        columns={WebUserRoleMappingSchema}
      />
    );
  }
);

export const Show = injectDataSource(
  ({ webUserRoleMapping, i18n, match }: any) => {
    const title = i18n.t("common:edit", {
      domain: "hns:webUserRoleMapping:domain"
    });
    const history = useHistory();
    return withBreadCrumbs(
      { to: match.url + "/edit", children: title },
      <ShowView
        dataSource={webUserRoleMapping.oneDataSource}
        title={title}
        fields={WebUserRoleMappingSchema}
        id={match.params}
        goBack={() => history.goBack()}
      />
    );
  }
);

export const Create = injectDataSource(
  ({ webUserRoleMapping, i18n, auth, match, ...rest }: any) => {
    const title = i18n.t("common:create", {
      domain: "hns:webUserRoleMapping:domain"
    });
    const history = useHistory();
    return withBreadCrumbs(
      { to: match.url + "/create", children: title },
      <CreateView
        dataSource={webUserRoleMapping.oneDataSource}
        {...rest}
        title={title}
        fields={WebUserRoleMappingSchema}
        id={match.params}
        goBack={() => history.goBack()}
      />
    );
  }
);
